/**
 * @deprecated This file is kept for backward compatibility only.
 * All course data should be fetched from the database via UnifiedCourseService.
 * DO NOT ADD NEW COURSES HERE - use database migrations instead.
 */

import { JAVA_BASIC_COURSE } from './basicCourse';
import { JAVA_INTERMEDIATE_COURSE } from './intermediateCourse';
import { JAVA_ADVANCED_COURSE } from './advancedCourse';
import { JavaCourse } from './types';

export { JAVA_BASIC_COURSE, JAVA_INTERMEDIATE_COURSE, JAVA_ADVANCED_COURSE };

export const JAVA_COURSES: JavaCourse[] = [
  JAVA_BASIC_COURSE,
  JAVA_INTERMEDIATE_COURSE,
  JAVA_ADVANCED_COURSE
];

// Course progression mapping for guided learning path
export const JAVA_LEARNING_PATH = {
  beginner: JAVA_BASIC_COURSE,
  intermediate: JAVA_INTERMEDIATE_COURSE,
  advanced: JAVA_ADVANCED_COURSE
};

// Validation function for Java course integration
export const validateJavaCourses = () => {
  return {
    totalCourses: JAVA_COURSES.length,
    courseIds: JAVA_COURSES.map(c => c.id),
    moduleCounts: JAVA_COURSES.map(c => ({
      courseId: c.id,
      moduleCount: c.modules.length,
      hasQuizzes: c.modules.every(m => m.quiz)
    })),
    integrationStatus: 'complete'
  };
};
